/**
 * App build version — surfaced in the sidebar / mobile header so you can confirm
 * which build an environment is actually running.
 *
 * Baked in at compile time from the CI git tag: the web Dockerfile sets
 * `ARG BUILD_VERSION` → `ENV VITE_BUILD_VERSION`, and CI passes the semver tag
 * (e.g. "0.1.0") via `--build-arg BUILD_VERSION`. Local `pnpm dev` and
 * unversioned Docker builds have no tag, so we fall back to 'dev'.
 */
export const APP_VERSION: string = import.meta.env.VITE_BUILD_VERSION || 'dev';

/** User-facing label, e.g. "Version: 0.1.0". */
export const APP_VERSION_LABEL = `Version: ${APP_VERSION}`;
